module.exports = __webpack_public_path__ + "img/fireworks2.34a7f5c3.svg";